import { MyAppList } from '../../../components/service/accounts/me/apps';

export const MyAppPageView = () => {
  return <MyAppList />;
};
